import { vytvorInvestPdfPrehlad,} from "./investPonukaPdfPrehlad";
import { pripravInvestPdfRentu, pripravInvestPdfScenare, } from "./investPdfRozsireneMoznosti";
import { maInvestPdfOdporucania, } from "./investPdfOdporucania";
import { maInvestPdfVyvoj, pripravInvestPdfPoznamku, } from "./investPdfPoznamkyVyvoj";

export const INVEST_PDF_SEKCIE = Object.freeze([
  {
    kluc: "zahrnutZakladnyVystup",
    label: "Základný výstup",
    predvolena: true,
    povinna: true,
  },
  {
    kluc: "zahrnutRozsirenyVystup",
    label: "Rozšírený výstup",
    predvolena: true,
  },
  {
    kluc: "zahrnutPoplatky",
    label: "Poplatky",
    predvolena: true,
  },
  {
    kluc: "zahrnutGrafy",
    label: "Grafy",
    predvolena: true,
    povinna: true,
  },
  {
    kluc: "zahrnutPoznamky",
    label: "Poznámky",
    predvolena: true,
    dostupnostKluc: "poznamky",
    },
  {
    kluc:
        "zahrnutNavrhInvesticnehoRiesenia",
    label:
        "Návrh investičného riešenia",
    predvolena: true,
    dostupnostKluc:
        "navrhInvesticnehoRiesenia",
    },
  {
    kluc: "zahrnutScenare",
    label: "Scenáre",
    predvolena: false,
    dostupnostKluc: "scenare",
  },
  {
    kluc: "zahrnutRentu",
    label: "Renta",
    predvolena: false,
    dostupnostKluc: "renta",
  },
  {
    kluc: "zahrnutVyvojInvesticie",
    label: "Vývoj investície – roky",
    predvolena: false,
    dostupnostKluc: "vyvojInvesticie",
    },
]);

function jeSekciaDostupna(sekcia, dostupnostSekcii) {
  if (!sekcia.dostupnostKluc) {
    return true;
  }

  return Boolean(
    dostupnostSekcii?.[sekcia.dostupnostKluc]
  );
}

export function vytvorPredvoleneInvestPdfSekcie(
  dostupnostSekcii = {}
) {
  return INVEST_PDF_SEKCIE.reduce(
    (vysledok, sekcia) => ({
      ...vysledok,
      [sekcia.kluc]:
        jeSekciaDostupna(
          sekcia,
          dostupnostSekcii
        ) && Boolean(sekcia.predvolena),
    }),
    {}
  );
}

export function normalizujInvestPdfSekcie(
  pdfSekcie,
  dostupnostSekcii = {}
) {
  return INVEST_PDF_SEKCIE.reduce(
    (vysledok, sekcia) => {
      const dostupna = jeSekciaDostupna(
        sekcia,
        dostupnostSekcii
      );

      return {
        ...vysledok,
        [sekcia.kluc]:
          dostupna &&
          (
            sekcia.povinna ||
            Boolean(pdfSekcie?.[sekcia.kluc])
          ),
      };
    },
    {}
  );
}

function datumVyhotoveniaText() {
  return new Intl.DateTimeFormat("sk-SK", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date());
}

export function vytvorDataPreInvesticnuPonukuPdf({
  nazovSuboru,
  menoKlienta,
  kontaktMeno,
  kontaktPriezvisko,
  kontaktEmail,
  kontaktTelefon,
  kontaktNbsCislo,
  pdfSekcie,
  dostupnostSekcii,
  porovnanieInvesticii,
  variant1,
  variant2,
  vysledkyInvesticii,
  grafy,
  scenare,
  renta,
  odporucania,
  poznamka,
    vyvojInvesticie,
}) {
  const sekcie = normalizujInvestPdfSekcie(
    pdfSekcie,
    dostupnostSekcii
  );

  const kontaktMenoCele = [
    kontaktMeno,
    kontaktPriezvisko,
  ]
    .map((hodnota) =>
      String(hodnota || "").trim()
    )
    .filter(Boolean)
    .join(" ");

  const aktivneSekcie = INVEST_PDF_SEKCIE
    .filter(
      (sekcia) => sekcie[sekcia.kluc]
    )
    .map((sekcia) => sekcia.label);

    const prehladInvesticie =
    vytvorInvestPdfPrehlad({
      porovnanieInvesticii,
      variant1,
      variant2,
      vysledkyInvesticii,
      sekcie,
    });

    const scenarePdf =
  sekcie.zahrnutScenare
    ? pripravInvestPdfScenare(
        scenare
      )
    : null;

    const rentaPdf =
        sekcie.zahrnutRentu
            ? pripravInvestPdfRentu(
                renta
            )
            : null;

    const odporucaniaPdf =
        sekcie
            .zahrnutNavrhInvesticnehoRiesenia &&
        maInvestPdfOdporucania(
            odporucania
        )
            ? odporucania
            : null;

    const poznamkaPdf =
        sekcie.zahrnutPoznamky
            ? pripravInvestPdfPoznamku(
                poznamka
            )
            : null;

        const vyvojInvesticiePdf =
          sekcie.zahrnutVyvojInvesticie &&
          maInvestPdfVyvoj(
            vyvojInvesticie
          )
            ? {
                ...vyvojInvesticie,

                zobrazitPoplatky:
                  Boolean(
                    sekcie
                      .zahrnutPoplatky &&
                    vyvojInvesticie
                      ?.zobrazitPoplatky
                  ),
              }
            : null;

  return {
    metadata: {
      nazovSuboru: String(
        nazovSuboru || ""
      ).trim(),
      menoKlienta: String(
        menoKlienta || ""
      ).trim(),
      datumVyhotovenia:
        datumVyhotoveniaText(),
      nazovDokumentu:
        "Informatívna investičná ponuka",
    },
    kontaktPdf: {
      meno: kontaktMenoCele,
      email: String(
        kontaktEmail || ""
      ).trim(),
      telefon: String(
        kontaktTelefon || ""
      ).trim(),
      nbsCislo: String(
        kontaktNbsCislo || ""
      ).trim(),
    },
    sekcie,
    aktivneSekcie,
    prehladInvesticie,
    grafy: grafy || null,
    scenarePdf,
    rentaPdf,
    odporucaniaPdf,
    poznamkaPdf,
    vyvojInvesticiePdf,
  };
}